const func = $target => {
    $(document).ready(function(){
        $('.viewBtn').attr('disabled',false);
    });
    var $product = $target.data('id');

    $("#next-"+$product+"").click(function() {
        var nextDiv = $(".slider-"+$product+":visible").next(".swiper-slide");

        $(".slider-"+$product).hide();
        $(this).addClass('swiper-button-disabled');
            $('#prev-'+$product).removeClass('swiper-button-disabled');
        nextDiv.show();
    });

    $("#prev-"+$product+"").click(function() {
        var prevDiv = $(".slider-"+$product+":visible").prev(".swiper-slide");

        $(".slider-"+$product).hide();
        $(this).addClass('swiper-button-disabled');
            $('#next-'+$product).removeClass('swiper-button-disabled');
        prevDiv.show();
    })

};

export default func;
